import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../Pages/NotFound.css";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found | Sri Rajalakshmi Travels</title>
        <meta name="robots" content="noindex, nofollow" />

        {/* JSON-LD for Search Engines */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "404 - Page Not Found",
            "description": "The page you are looking for is not available.",
            "url": "https://srirajalakshmitravels.in/404"
          })}
        </script>
      </Helmet>

      <Navbar />

      <section className="error-section">
        <h1 className="error-code">404</h1>
        <p className="error-text">Oops! This page doesn’t exist.</p>

        <a href="/" className="error-btn">Go Back Home</a>
      </section>

      <Footer />
    </>
  );
}
